import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Observable } from "rxjs";
import { FaqInfo } from "../core";
import { FaqService } from "./faq.service";

@Component({
  selector: "brd-faq",
  templateUrl: "./faq.component.html",
  styleUrl: "./faq.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqComponent {
  faqInfo$: Observable<FaqInfo>;
  constructor(private faqService: FaqService) {
    this.faqInfo$ = this.faqService.getFaqInfo();
  }
}
